import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { VestaConfig } from '../models/vesta-config.model';
import { firstValueFrom } from 'rxjs';
import {environment} from "../../../../environments/environment";

@Injectable({ providedIn: 'root' })
export class VestaConfigLoaderService {
  private http = inject(HttpClient);
  private readonly _config = signal<VestaConfig | null>(null);
  private readonly config = this._config.asReadonly();

  public load(): Promise<void> {
    let configUrl = '/assets/config/vesta.stage.config.json'

    if (environment.prodMode) {
      configUrl = '/assets/config/vesta.config.json'
    }

    console.log('Load vesta config...', configUrl);

    return firstValueFrom(this.http.get<VestaConfig>(configUrl)).then(cfg => {
      this._config.set(cfg);
    });
  }

  public getSnapshot(): VestaConfig {
    const cfg = this._config();
    if (!cfg) {
      throw new Error('[VestaConfig] accessed before initialization');
    }
    return cfg;
  }
}
